import { apiPost } from "shared/services/apiRequest";

const updateDeviceMasterControlService = async (category, deviceIds, deviceType, data) =>
    (await apiPost(`/${category}/master-control`, { deviceIds, deviceType, ...data }))?.data;

export const updateSwitchesMasterControlService = (...args) =>
    updateDeviceMasterControlService("switches", ...args);

export const updateBlowersMasterControlService = (...args) =>
    updateDeviceMasterControlService("blowers", ...args);
